import { createFileRoute, Link } from "@tanstack/react-router";
import { motion } from "motion/react";
import { ArrowRight, Calendar, Clock } from "lucide-react";

export const Route = createFileRoute("/blog")({
  head: () => ({
    meta: [
      { title: "Blog — PRICO" },
      { name: "description", content: "Consejos, tendencias y trucos para ahorrar en el mercado y compras diarias." },
      { property: "og:title", content: "Blog — PRICO" },
      { property: "og:description", content: "Tips de ahorro y comparación de precios." },
      { property: "og:url", content: "/blog" },
    ],
    links: [{ rel: "canonical", href: "/blog" }],
  }),
  component: BlogPage,
});

const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] as const },
};

const posts = [
  { t: "5 trucos para reducir tu mercado mensual sin sacrificar calidad", c: "Ahorro", min: 6, d: "15 Jun 2026" },
  { t: "Cómo aprovechar las quincenas para comprar medicinas más baratas", c: "Salud", min: 4, d: "08 Jun 2026" },
  { t: "Marca propia vs marca tradicional: ¿realmente ahorras?", c: "Consumo", min: 8, d: "30 May 2026" },
  { t: "El precio de la canasta básica en Colombia: tendencias 2026", c: "Tendencias", min: 10, d: "22 May 2026" },
  { t: "Inteligencia artificial y compras: el futuro del consumidor", c: "Tecnología", min: 7, d: "10 May 2026" },
  { t: "Listas de compras: el método que reduce tu factura un 25%", c: "Ahorro", min: 5, d: "02 May 2026" },
];

function BlogPage() {
  return (
    <>
      <section className="container-prico py-20 md:py-28 text-center max-w-3xl mx-auto">
        <motion.div {...fadeUp}>
          <span className="chip">Blog</span>
          <h1 className="text-5xl md:text-7xl font-black mt-5 leading-[1]">
            Aprende a <span style={{ background: "var(--gradient-primary)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>ahorrar</span> como un experto.
          </h1>
          <p className="mt-6 text-lg text-muted-foreground">
            Ideas, datos y trucos para gastar menos sin renunciar a lo que te gusta.
          </p>
        </motion.div>
      </section>

      <section className="container-prico pb-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((p, i) => (
            <motion.article key={p.t} {...fadeUp} transition={{ ...fadeUp.transition, delay: i * 0.05 }}
              className="card-soft overflow-hidden group cursor-pointer">
              <div className="aspect-[16/10] relative overflow-hidden" style={{ background: "var(--gradient-warm)" }}>
                <div className="absolute inset-0 grid place-items-center">
                  <span className="font-display font-black text-7xl text-primary/30 group-hover:scale-110 transition">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <span className="absolute top-4 left-4 chip">{p.c}</span>
              </div>
              <div className="p-6">
                <h3 className="font-bold text-lg leading-snug group-hover:text-primary transition">{p.t}</h3>
                <div className="flex items-center gap-4 mt-4 text-xs text-muted-foreground">
                  <span className="flex items-center gap-1.5"><Calendar className="size-3.5" /> {p.d}</span>
                  <span className="flex items-center gap-1.5"><Clock className="size-3.5" /> {p.min} min</span>
                </div>
              </div>
            </motion.article>
          ))}
        </div>

        <motion.div {...fadeUp} className="card-soft mt-16 p-10 md:p-14 text-center" style={{ background: "var(--gradient-warm)" }}>
          <h3 className="text-3xl md:text-4xl font-black max-w-xl mx-auto">Recibe los mejores tips de ahorro</h3>
          <p className="text-muted-foreground mt-3">Un correo al mes. Sin spam. Solo valor.</p>
          <Link to="/contacto" className="btn-primary mt-6">Suscribirme <ArrowRight className="size-4" /></Link>
        </motion.div>
      </section>
    </>
  );
}
